import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { QualifierColors } from '../HelperClass/LeagueQualifierIndicator'
import CaptionFont from '../../../Theme/Fonts/Caption'
import { SpacingProps } from '../../../utils/styling/StylingHelper'
import { mapSpaceValue } from '../../../Layouts/LayoutUtils'

export type StandingsLegendRowProps = {
    /**
     * color of league qualifier
     * */
    color: QualifierColors
    /**
     * label for the qualifier color
     * */
    label: string
} & TestID &
    Pick<SpacingProps, 'spaceTop' | 'spaceBottom'>

const StandingsLegendRow: FunctionComponent<StandingsLegendRowProps> = ({
    color,
    label,
    testID,
    spaceTop,
    spaceBottom,
}) => (
    <Grid
        testID={testID}
        horizontal
        backgroundColor="pearl"
        centerVertical
        marginTop={mapSpaceValue(spaceTop)}
        marginBottom={mapSpaceValue(spaceBottom)}
    >
        <Grid
            width={10}
            height={10}
            borderRadius={5}
            noExpand
            backgroundColor={color}
            marginRight={3}
        />
        <CaptionFont color="keshi-3">{label}</CaptionFont>
    </Grid>
)

export default StandingsLegendRow
